/**
 * ホームページ固有の機能
 */

/**
 * ホームページの初期化とイベント設定
 */
function initializeHomePage() {
  let topFixmenu = "";
  topFixmenu = new FixMenu(sitenav);
  topFixmenu.init();

  // ウィンドウリサイズ時に固定メニューの位置を更新
  // calculateFixTop() は common.js の FixMenu クラス内の resize イベントで自動的に呼び出されるため、
  // ここでは上書きせずに calculateFixTop() メソッドを呼び出す
  $w.on("resize", function() {
    topFixmenu.calculateFixTop();
  });

  // お問い合わせフォーム送信ボタンのクリックイベント
  $("#form-submit").on("click", function() {
    dataLayer.push({
      event: "analytics_event",
      eventCategory: "お問い合わせフォーム",
      eventAction: "click",
      eventLabel: "お問い合わせ送信ボタンクリック"
    });
  });
}

imagesLoaded(document.querySelector(".wrap"), function() {
  init();
  setupCommonEventListeners();
  initializeHomePage();
});
